import {
  ApiError as ApiErrorType,
  isFieldError,
  isValidationError,
  isServerError,
} from "../types/api"

// API Configuration
export const API_BASE_URL = "http://localhost:8000"
export const API_PREFIX = "/birddog"

// Base API Error class
export class ApiError extends Error {
  constructor(
    message: string,
    public status?: number,
    public apiError?: ApiErrorType
  ) {
    super(message)
    this.name = "ApiError"
  }
}

// Format API errors for user display
export const formatApiError = (apiError: ApiErrorType): string => {
  if (isFieldError(apiError)) {
    // Handle field validation errors
    const fieldErrors: string[] = []
    for (const [field, messages] of Object.entries(apiError)) {
      // Ensure messages is an array before calling join
      const messageArray = Array.isArray(messages) ? messages : [messages]
      fieldErrors.push(`${field}: ${messageArray.join(", ")}`)
    }
    return `Validation errors:\n${fieldErrors.join("\n")}`
  }

  if (isValidationError(apiError)) {
    // Handle model validation errors
    return `${apiError.error}: ${apiError.details}`
  }

  if (isServerError(apiError)) {
    // Handle server errors
    return `Server error: ${apiError.error}`
  }

  return "An unexpected error occurred"
}
